"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const FooterLinks_1 = __importDefault(require("./FooterLinks"));
exports.default = FooterLinks_1.default;
